// import IsRtl from "components/Shared/isRtl";
import IsRtl from "components/Shared/isRtl";
import Image from "next/image";

const FooterDecorativeOverlaySvg = () => (
  <Image alt="footer decorative overlay" aria-hidden="true" aria-label="footer decorative overlay" className={`${IsRtl() ? "" : "scale-x-[-1] scale-y-[1]"}`}   loading="lazy" src={"/FooterLogoFoundingDay.png"} layout="fill" />

);

export default FooterDecorativeOverlaySvg;
